module.exports = __webpack_public_path__ + "static/media/test.b4678d99.png";